import React from 'react';

const MedalStarIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "28",
    height: "29",
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M24.7917 22.4594L22.8667 22.9144C22.435 23.0194 22.0967 23.3461 22.0034 23.7778L21.595 25.4928C21.3734 26.4261 20.1834 26.7178 19.565 25.9828L16.0767 21.9694C15.7967 21.6428 15.9484 21.1294 16.3684 21.0244C18.4334 20.5228 20.2884 19.3678 21.6534 17.7228C21.875 17.4544 22.2717 17.4194 22.5167 17.6644L25.1067 20.2544C25.9934 21.1411 25.6784 22.2494 24.7917 22.4594Z",
      fill: "#FF961C"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.14995 22.4594L5.07495 22.9144C5.50661 23.0194 5.84495 23.3461 5.93828 23.7778L6.34661 25.4928C6.56828 26.4261 7.75828 26.7178 8.37661 25.9828L11.8649 21.9694C12.1449 21.6428 11.9933 21.1294 11.5733 21.0244C9.50828 20.5228 7.65328 19.3678 6.28828 17.7228C6.06661 17.4544 5.66995 17.4194 5.42495 17.6644L2.83495 20.2544C1.94828 21.1411 2.26328 22.2494 3.14995 22.4594Z",
      fill: "#FF961C"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.9999 3.24463C9.48492 3.24463 5.83325 6.8963 5.83325 11.4113C5.83325 13.103 6.33492 14.6546 7.19825 15.9496C8.45825 17.8163 10.4533 19.1346 12.7749 19.473C13.1716 19.543 13.5799 19.578 13.9999 19.578C14.4199 19.578 14.8283 19.543 15.2249 19.473C17.5466 19.1346 19.5416 17.8163 20.8016 15.9496C21.6649 14.6546 22.1666 13.103 22.1666 11.4113C22.1666 6.8963 18.5149 3.24463 13.9999 3.24463ZM17.5699 11.1546L16.6016 12.123C16.4383 12.2863 16.3449 12.6013 16.4033 12.8346L16.6833 14.0363C16.9049 14.9813 16.4033 15.3546 15.5633 14.853L14.3966 14.1646C14.1866 14.0363 13.8366 14.0363 13.6266 14.1646L12.4599 14.853C11.6199 15.343 11.1183 14.9813 11.3399 14.0363L11.6199 12.8346C11.6666 12.613 11.5849 12.2863 11.4216 12.123L10.4299 11.1546C9.85825 10.583 10.0449 10.0113 10.8383 9.88296L12.0866 9.67296C12.2966 9.63796 12.5416 9.4513 12.6349 9.26463L13.3233 7.88796C13.6966 7.1413 14.3033 7.1413 14.6766 7.88796L15.3649 9.26463C15.4583 9.4513 15.7033 9.63796 15.9249 9.67296L17.1733 9.88296C17.9549 10.0113 18.1416 10.583 17.5699 11.1546Z",
      fill: "#FF961C"
    }
  )
);
MedalStarIcon.displayName = "Icons.MedalStarIcon";

export { MedalStarIcon };
//# sourceMappingURL=MedalStarIcon.js.map
